import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d4d8ba0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-more-popover__content" }
const _hoisted_2 = { class: "task-more-popover__option-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Скопировать название и ссылку", -1))
const _hoisted_4 = { class: "task-more-popover__option" }
const _hoisted_5 = { class: "task-more-popover__option-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Открепить родительскую задачу", -1))
const _hoisted_7 = { class: "task-more-popover__confirm-popover" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-more-popover__confirm-popover-message" }, " Открепить родительскую задачу? ", -1))
const _hoisted_9 = { class: "task-more-popover__confirm-popover-buttons" }
const _hoisted_10 = { class: "task-more-popover__option" }
const _hoisted_11 = { class: "task-more-popover__option-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Сменить родительскую задачу", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-right" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "task-more-popover__option-svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.21967 7.21967C9.51256 6.92678 9.98744 6.92678 10.2803 7.21967L14.5303 11.4697C14.671 11.6103 14.75 11.8011 14.75 12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L10.2803 16.7803C9.98744 17.0732 9.51256 17.0732 9.21967 16.7803C8.92678 16.4874 8.92678 16.0126 9.21967 15.7197L12.9393 12L9.21967 8.28033C8.92678 7.98744 8.92678 7.51256 9.21967 7.21967Z"
    })
  ])
], -1))
const _hoisted_14 = { class: "task-more-popover__option" }
const _hoisted_15 = { class: "task-more-popover__option-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Назначить родительскую задачу", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-right" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "task-more-popover__option-svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.21967 7.21967C9.51256 6.92678 9.98744 6.92678 10.2803 7.21967L14.5303 11.4697C14.671 11.6103 14.75 11.8011 14.75 12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L10.2803 16.7803C9.98744 17.0732 9.51256 17.0732 9.21967 16.7803C8.92678 16.4874 8.92678 16.0126 9.21967 15.7197L12.9393 12L9.21967 8.28033C8.92678 7.98744 8.92678 7.51256 9.21967 7.21967Z"
    })
  ])
], -1))
const _hoisted_18 = { class: "task-more-popover__option-left" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Посмотреть карту проекта", -1))
const _hoisted_20 = { class: "task-more-popover__option-left" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Скопировать тикет в другую очередь", -1))
const _hoisted_22 = { class: "task-more-popover__option-left" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Перенести тикет в другую очередь", -1))
const _hoisted_24 = { class: "task-more-popover__option-left" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-more-popover__option-middle" }, "Удалить тикет", -1))

import { computed, inject, onMounted, onUnmounted, PropType, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import {
  TirPmPopover,
  PopoverPositionType,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmRouterLink,
} from 'tir-components';
import {
  ConnectIcon,
  ShareIcon,
  MapIcon,
  PencilSquareIcon,
  TrashIcon,
  ArrowUpRightIcon,
} from 'tir-style-system/icons/outline';
import {
  SubtasksSearchFunctionType,
  TaskSubtasksSearchDropdown,
} from '../task-subtasks-search-dropdown';
import { TaskCopyingModal, RemoveTaskModal, TimeTrackerRecordModel } from '@/components';
import PerformerListByOrder from '@/components/tasks-kanban/components/PerformerListByOrder.vue';
import { TaskModel } from '@/components/tasks-kanban/models';
import { SubtaskModel } from '../../models';
import { TaskTransferModal } from '../task-transfer-modal';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-more-popover',
  props: {
  /**ID очереди */
  queueId: { type: String },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Открыть в виде шторки */
  showAsDrawer: { type: Boolean, default: false },
  /**Подзадачи */
  subtasks: { type: Array as PropType<SubtaskModel[]> },
  /**наличие подзадач */
  isSubtasks: { type: Boolean },
  /**Прикрепленные очереди */
  attachedQueues: { type: Boolean },
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**Задача */
  task: {
    type: Object as PropType<TaskModel>,
    required: true,
  },
  /**Родительская задача */
  isParentalTask: { type: Boolean },
  /**Id задачи */
  taskId: { type: Number, required: true },
  /**ID проекта */
  projectId: { type: Number, required: true },
  /**Имя задачи */
  taskName: { type: String, required: true },
  /**Режим редактирования */
  editing: {
    type: Boolean,
    default: true,
  },
  /**ID родительской задачи */
  parentTaskId: {
    type: Number,
  },
  /**Кастомная позиция поповера */
  customPosition: {
    type: Object as PropType<PopoverPositionType>,
    default: (): PopoverPositionType => ({
      right: '0rem',
      top: '$el:height + 0.25rem',
    }),
  },
  /**Функция поиска задач */
  searchTasksFunction: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Загрузка при откреплении задачи */
  isLoadingUnattachButton: {
    type: Boolean,
    default: false,
  },
  /**Показывать ли удаление */
  showRemove: { type: Boolean },
},
  emits: ["attachParentTask", "unattachParentTask", "changeParentTask", "copyTaskLink", "successRemove", "transferTask"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


/**Является ли текущий юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

/**Окно для копирования задачи */
const $taskCopyingModal = ref<InstanceType<typeof TaskCopyingModal>>();
/**Окно для переноса задачи */
const $taskTransferModal = ref<InstanceType<typeof TaskTransferModal>>();
const $popover = ref<InstanceType<typeof TirPmPopover>>();
const transferTask = ref<boolean>();

const $container = ref<HTMLElement>();

const $confirmUnattachPopover = ref<InstanceType<typeof TirPmPopover>>();
/**Окно для удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();

const pageScrollSelector = inject<string | undefined>('popover-scroll-selector');
let pageScrollElement: HTMLElement | undefined;

/**Доступ к добавлению задачи в очередность исполнителя */
const accessAddQueue = computed(() => props.userAccess.CanCustomizeOrder || isOwner);

onMounted(() => {
  pageScrollElement = pageScrollSelector && $container.value?.closest(pageScrollSelector);
  pageScrollElement?.addEventListener('scroll', onScroll);
});
onUnmounted(() => {
  pageScrollElement?.removeEventListener('scroll', onScroll);
});

const onScroll = () => {
  $confirmUnattachPopover.value?.close();
};

const attachParentTask = (value) => {
  emit('attachParentTask', value);
  $popover.value?.close();
};

const unattachParentTask = () => {
  emit('unattachParentTask');
  $popover.value?.close();
};

const changeParentTask = (value) => {
  emit('changeParentTask', value);
  $popover.value?.close();
};

const copyTaskLink = () => {
  emit('copyTaskLink');
  $popover.value?.close();
};
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.taskId,
      projectId: props.projectId,
    },
  });
});
/**Подтвержденное удаление задачи */
const successRemove = () => {
  emit('successRemove');
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Открытие окна для копирования задачи */
const openCopyModal = () => {
  $popover.value?.close();
  $taskCopyingModal.value?.toggle(true);
};
/**Открытие окна для переноса задачи */
const openTransferModal = (taskId: number) => {
  $popover.value?.close();
  if (props.subtasks?.length || props.task.Parent || props.task.QueueToTaskRelationList.length) {
    addNotification('Невозможно перенести тикет с родительским/дочерними тикетами', true);
  } else {
    $taskTransferModal.value?.toggle(true, taskId);
  }
};

/**Перенос задачи */
const transferTaskEvent = () => {
  emit('transferTask');
};

/**Открыть окно для подтверждения удаления задачи */
const removeTask = () => {
  $popover.value?.close();
  $removeTaskModal.value?.open(props.taskId, props.taskName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "task-more-popover",
      ref_key: "$container",
      ref: $container
    }, [
      _createVNode(_unref(TirPmPopover), {
        ref_key: "$popover",
        ref: $popover,
        "custom-position": __props.customPosition
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "task-more-popover__option",
              onClick: copyTaskLink
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(ShareIcon))
              ]),
              _hoisted_3
            ]),
            (__props.parentTaskId)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(TirPmPopover), {
                    class: "task-more-popover__option-popover",
                    ref_key: "$confirmUnattachPopover",
                    ref: $confirmUnattachPopover,
                    "is-no-teleport": "",
                    "disable-content-blur": "",
                    "custom-position": {
                left: '0rem',
                bottom: '0.313rem',
              }
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(TirPmButton), {
                            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                            size: _unref(TirPmButtonSizeEnum).Small,
                            "is-loading": __props.isLoadingUnattachButton,
                            onClick: _withModifiers(unattachParentTask, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Открепить ")
                            ]),
                            _: 1
                          }, 8, ["variant", "size", "is-loading", "onClick"]),
                          _createVNode(_unref(TirPmButton), {
                            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                            size: _unref(TirPmButtonSizeEnum).Small,
                            "is-disabled": __props.isLoadingUnattachButton,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($confirmUnattachPopover.value?.close()), ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Отмена ")
                            ]),
                            _: 1
                          }, 8, ["variant", "size", "is-disabled"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(ConnectIcon))
                        ]),
                        _hoisted_6
                      ])
                    ]),
                    _: 1
                  }, 512),
                  _createVNode(_unref(TaskSubtasksSearchDropdown), {
                    "search-function": __props.searchTasksFunction,
                    "custom-popover-position": __props.customPosition,
                    "no-teleport": "",
                    "disable-content-blur": "",
                    "close-by-select": "",
                    onOnSelect: changeParentTask
                  }, {
                    target: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_unref(ConnectIcon))
                        ]),
                        _hoisted_12,
                        _hoisted_13
                      ])
                    ]),
                    _: 1
                  }, 8, ["search-function", "custom-popover-position"])
                ], 64))
              : _createCommentVNode("", true),
            (!__props.parentTaskId && __props.editing)
              ? (_openBlock(), _createBlock(_unref(TaskSubtasksSearchDropdown), {
                  key: 1,
                  queueId: __props.queueId,
                  "search-function": __props.searchTasksFunction,
                  "custom-popover-position": __props.customPosition,
                  "no-teleport": "",
                  "disable-content-blur": "",
                  closeBySelect: "",
                  onOnSelect: attachParentTask
                }, {
                  target: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_unref(ConnectIcon))
                      ]),
                      _hoisted_16,
                      _hoisted_17
                    ])
                  ]),
                  _: 1
                }, 8, ["queueId", "search-function", "custom-popover-position"]))
              : _createCommentVNode("", true),
            (__props.editing)
              ? (_openBlock(), _createBlock(_unref(TirPmRouterLink), {
                  key: 2,
                  isDisabled: !props.taskId,
                  to: openSchema.value,
                  class: "task-more-popover__option"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(MapIcon))
                    ]),
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["isDisabled", "to"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "task-more-popover__option",
              onClick: openCopyModal
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(PencilSquareIcon))
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", {
              class: "task-more-popover__option",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openTransferModal(__props.taskId)))
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(ArrowUpRightIcon))
              ]),
              _hoisted_23
            ]),
            (accessAddQueue.value)
              ? (_openBlock(), _createBlock(PerformerListByOrder, {
                  key: 3,
                  taskInfo: __props.task,
                  onClosePopover: _cache[2] || (_cache[2] = ($event: any) => ($popover.value.close()))
                }, null, 8, ["taskInfo"]))
              : _createCommentVNode("", true),
            (__props.showRemove)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "task-more-popover__option red",
                  onClick: removeTask
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(TrashIcon))
                  ]),
                  _hoisted_25
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["custom-position"])
    ], 512),
    _createVNode(_unref(TaskCopyingModal), {
      ref_key: "$taskCopyingModal",
      ref: $taskCopyingModal,
      "task-id": __props.taskId,
      isParentalTask: __props.isParentalTask,
      attachedQueues: __props.attachedQueues,
      isSubtasks: __props.isSubtasks
    }, null, 8, ["task-id", "isParentalTask", "attachedQueues", "isSubtasks"]),
    _createVNode(_unref(TaskTransferModal), {
      ref_key: "$taskTransferModal",
      ref: $taskTransferModal,
      projectId: __props.projectId,
      "task-id": __props.taskId,
      isParentalTask: __props.isParentalTask,
      attachedQueues: __props.attachedQueues,
      isSubtasks: __props.isSubtasks,
      onTransferTask: transferTaskEvent
    }, null, 8, ["projectId", "task-id", "isParentalTask", "attachedQueues", "isSubtasks"]),
    _createVNode(_unref(RemoveTaskModal), {
      ref_key: "$removeTaskModal",
      ref: $removeTaskModal,
      timerTrackerRecords: __props.timerTrackerRecords,
      transferTask: transferTask.value,
      onSuccessRemove: successRemove
    }, null, 8, ["timerTrackerRecords", "transferTask"])
  ], 64))
}
}

})